import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from "react-router-redux";
import store, { history } from "./store";
import ldRedux from 'ld-redux';


import App from "./App";
import * as serviceWorker from "./serviceWorker";

import "./index.css";

const target = document.querySelector("#root");

const flags = { 'show-pwd-reset-required-prompt': false };

ldRedux.init({
  clientSideId: process.env.REACT_APP_LAUNCH_DARKLY_CLIENT_ID,
  dispatch: store.dispatch,
  flags,
});

render(
  <Provider store={store}>
    <ConnectedRouter store={store} history={history}>
      <div>
        <App />
      </div>
    </ConnectedRouter>
  </Provider>,
  target
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
